import {
  differenceInDays,
  differenceInWeeks,
  distanceInWordsStrict,
  isAfter,
} from 'date-fns';
import pluralize from 'pluralize';

import { Dateable, TimeSpanFormatter } from '../types';

const formatTimeSpan: TimeSpanFormatter = (
  endDate: Dateable,
  startDate: Dateable,
  addSuffix = true
) => {
  // `distanceInWords` does not support weeks resolution
  const fullWeeks = Math.abs(differenceInWeeks(endDate, startDate));
  if (fullWeeks > 0 && fullWeeks < 4) {
    const remainderDays = Math.abs(differenceInDays(endDate, startDate)) % 7;
    const weeks = remainderDays < 4 ? fullWeeks : fullWeeks + 1;
    const isEndAfter = isAfter(startDate, endDate);
    const prefix = addSuffix && isEndAfter ? 'in ' : '';
    const suffix = addSuffix && !isEndAfter ? ' ago' : '';
    return `${prefix}${weeks} ${pluralize('week', weeks)}${suffix}`;
  }

  return distanceInWordsStrict(endDate, startDate, { addSuffix });
};

export default formatTimeSpan;
